const menu = [
  {
    icon: "dashboard-fill",
    text: "Dashboard",
    link: "/",
  },
  {
    icon: "bag-fill",
    text: "Orders",
    link: "/orders",
  },
  {
    icon: "wallet-fill",
    text: "Payments",
    link: "/payments",
  },
  {
    icon: "repeat-fill",
    text: "Return/Exchange",
    link: "/exchange",
  },
  {
    icon: "truck",
    text: "Shipping",
    link: "/shipping",
  },
  {
    icon: "layers-fill",
    text: "Categories",
    link: "/category",
  },
  {
    icon: "package-fill",
    text: "Products",
    link: "/products",
  },
  {
    icon: "users-fill",
    text: "Customers",
    link: "/customer",
  },
  {
    icon: "star-fill",
    text: "Reviews",
    link: "/reviews",
  },
  {
    icon: "star-fill",
    text: "Public Reviews",
    link: "/public-reviews",
  },
  {
    icon: "book-fill",
    text: "Blogs",
    link: "/blogs",
  },
  {
    icon: "emails-fill",
    text: "Contacts Query",
    link: "/contacts",
  },
  {
    icon: "presentation-fill",
    text: "Slider Management",
    link: "/sliders",
  },
  {
    icon: "setting-fill",
    text: "Settings",
    link: "/settings",
  },
];

export default menu;
